import Icon from "@/components/shared/Icon";

// Decorative floating educational objects. Purely visual (aria-hidden).
// Animations auto-disable under prefers-reduced-motion via index.css.
const ITEMS = [
  { name: "BookOpen", top: "12%", left: "6%", size: 34, color: "#147DEB", cls: "anim-float-slow", delay: "0s" },
  { name: "Star", top: "20%", left: "88%", size: 22, color: "#FFC928", cls: "anim-twinkle", delay: "0.4s" },
  { name: "Send", top: "62%", left: "10%", size: 26, color: "#45C878", cls: "anim-drift", delay: "0.2s" },
  { name: "Cloud", top: "8%", left: "60%", size: 40, color: "#E8F5FF", cls: "anim-float-medium", delay: "0.6s" },
  { name: "Sparkles", top: "74%", left: "82%", size: 24, color: "#FF91B8", cls: "anim-twinkle", delay: "1s" },
  { name: "Leaf", top: "44%", left: "94%", size: 22, color: "#45C878", cls: "anim-float-slow", delay: "0.8s" },
  { name: "Star", top: "52%", left: "3%", size: 18, color: "#FFC928", cls: "anim-twinkle", delay: "1.4s" },
];

export default function FloatingDecor({ className = "" }) {
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {ITEMS.map((it, i) => (
        <span
          key={i}
          className={`absolute ${it.cls}`}
          style={{ top: it.top, left: it.left, animationDelay: it.delay }}
        >
          <Icon name={it.name} style={{ width: it.size, height: it.size, color: it.color }} strokeWidth={2.2} />
        </span>
      ))}
    </div>
  );
}
